import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { exchangeSession } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

// Module-level guard: survives React.StrictMode double-mount.
// Maps session_id → in-flight Promise, so concurrent renders share it.
const inFlightExchanges = new Map();

function exchangeOnce(sessionId) {
  let p = inFlightExchanges.get(sessionId);
  if (!p) {
    p = exchangeSession(sessionId);
    inFlightExchanges.set(sessionId, p);
  }
  return p;
}

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const fragment = location.hash || window.location.hash || "";
    const match = fragment.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    let cancelled = false;
    exchangeOnce(sessionId)
      .then((data) => {
        if (cancelled) return;
        setUser(data.user);
        // Remove the fragment from URL, keep the pathname (e.g. /calculator)
        const returnPath = window.location.pathname || "/";
        window.history.replaceState(null, "", returnPath);
        navigate(returnPath, { replace: true });
        toast.success(`Bienvenue ${data.user.name || data.user.email} !`);
      })
      .catch((e) => {
        if (cancelled) return;
        console.error("Auth exchange failed", e);
        setError("Connexion impossible. Veuillez réessayer.");
        // Keep the session_id in URL removed to allow a clean retry.
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      });

    return () => { cancelled = true; };
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center px-4">
        {error ? (
          <div className="text-red-600 font-medium">{error}</div>
        ) : (
          <>
            <div className="inline-block h-10 w-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
            <div className="mt-4 text-sm font-mono-data text-slate-500">
              Connexion en cours…
            </div>
          </>
        )}
      </div>
    </div>
  );
}
